export type IconProps = React.HTMLAttributes<SVGElement>;

export const ThumbaCoin = (props: IconProps) => {
  const gradientId = "thumba-coin-gradient";

  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_10987_26031)">
        <path
          d="M15.7765 31.553C24.4896 31.553 31.553 24.4896 31.553 15.7765C31.553 7.06337 24.4896 0 15.7765 0C7.06337 0 0 7.06337 0 15.7765C0 24.4896 7.06337 31.553 15.7765 31.553Z"
          fill="#FFDD15"
        />
        <path
          d="M27.3794 5.06777C27.3045 4.99291 27.2289 4.92019 27.153 4.84711C33.092 11.0242 33.0189 20.846 26.9323 26.9323C20.8457 33.0188 11.0239 33.0916 4.84717 27.1529C4.91989 27.2289 4.99297 27.3044 5.06783 27.3793C11.2289 33.5404 21.2183 33.5404 27.3794 27.3793C33.5404 21.2182 33.5404 11.2289 27.3794 5.06777Z"
          fill="#D87D13"
        />
        <path d="M15.7765 0C7.06334 0 0 7.06334 0 15.7765H31.5533C31.5533 7.06334 24.49 0 15.7765 0Z" fill="#FFEE71" />
        <path
          d="M15.7765 28.9103C23.0301 28.9103 28.9103 23.0301 28.9103 15.7765C28.9103 8.52282 23.0301 2.64258 15.7765 2.64258C8.52282 2.64258 2.64258 8.52282 2.64258 15.7765C2.64258 23.0301 8.52282 28.9103 15.7765 28.9103Z"
          fill="#FABF03"
        />
        <path
          d="M15.7765 2.64294C8.52276 2.64294 2.64258 8.52312 2.64258 15.7768H28.91C28.91 8.52312 23.0298 2.64294 15.7761 2.64294H15.7765Z"
          fill="#F7C908"
        />
        <path
          d="M3.08974 16.2235C3.08974 8.9698 8.96992 3.08962 16.2236 3.08962C19.7368 3.08962 22.9276 4.46885 25.2847 6.71576C22.8927 4.20648 19.5175 2.64294 15.7769 2.64294C8.52324 2.64294 2.64307 8.52312 2.64307 15.7768C2.64307 19.5174 4.2066 22.8926 6.71588 25.2846C4.46933 22.9279 3.08974 19.737 3.08974 16.2235Z"
          fill="#D87D13"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9565 12.601L10.8343 13.6594L20.4059 22.6614L18.5767 24.3878L9.00448 15.3852L6.99724 17.2784C6.95125 17.3217 6.87278 17.3166 6.8322 17.2656L5.4605 15.3947C5.43074 15.3539 5.43615 15.3004 5.47403 15.2672L7.17307 13.6628L7.17238 13.6621L9.00161 11.9358L9.00177 11.9359L10.1221 10.8779L11.9538 12.601H11.9565ZM15.0921 11.0225L12.0721 13.8728L13.9045 15.5961L16.9245 12.7459L15.0921 11.0225ZM17.4264 13.2203L14.4064 16.0705L16.2388 17.7939L19.2589 14.9437L17.4264 13.2203ZM16.7416 18.2661L22.0114 13.2926L23.8438 15.016L18.574 19.9895L16.7416 18.2661ZM24.3482 15.4904L19.0784 20.4639L20.9108 22.1873L26.1806 17.2138L24.3482 15.4904Z"
          fill="#D87D13"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9565 11.7231L10.8343 12.7814L20.4059 21.7835L18.5767 23.5098L9.0045 14.5073L6.99724 16.4004C6.95125 16.4438 6.87278 16.4387 6.8322 16.3877L5.4605 14.5168C5.43074 14.476 5.43615 14.4224 5.47403 14.3893L7.17309 12.7848L7.17238 12.7842L9.00161 11.0578L9.00179 11.058L10.1221 10L11.9538 11.7231H11.9565ZM15.0921 10.1446L12.0721 12.9948L13.9045 14.7182L16.9245 11.868L15.0921 10.1446ZM17.4264 12.3424L14.4064 15.1926L16.2388 16.916L19.2589 14.0657L17.4264 12.3424ZM16.7416 17.3882L22.0114 12.4147L23.8438 14.1381L18.574 19.1116L16.7416 17.3882ZM24.3482 14.6125L19.0784 19.586L20.9108 21.3094L26.1806 16.3359L24.3482 14.6125Z"
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <linearGradient id={gradientId} x1={15.811} y1={10} x2={15.811} y2={23.5098} gradientUnits="userSpaceOnUse">
          <stop offset={0.455} stopColor="#FFEE71" />
          <stop offset={0.4551} stopColor="#FFDD15" />
        </linearGradient>
        <clipPath id="clip0_10987_26031">
          <rect width={32} height={32} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
